var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8672 2.96337C13.2137 2.77091 13.6036 2.66992 14 2.66992C14.3964 2.66992 14.7863 2.77091 15.1328 2.96337L23.9003 7.83304C24.0821 7.93412 24.2335 8.08195 24.339 8.26123C24.4444 8.44051 24.5 8.64472 24.5 8.8527V18.4602C24.4999 18.8763 24.3885 19.2848 24.1775 19.6434C23.9664 20.0019 23.6633 20.2975 23.2995 20.4995L15.1328 25.0379C14.7863 25.2303 14.3964 25.3313 14 25.3313C13.6036 25.3313 13.2137 25.2303 12.8672 25.0379L4.7005 20.4995C4.33691 20.2976 4.0339 20.0022 3.82283 19.6439C3.61176 19.2855 3.50031 18.8773 3.5 18.4614V8.8527C3.49999 8.64472 3.55558 8.44051 3.66102 8.26123C3.76645 8.08195 3.9179 7.93412 4.09967 7.83304L12.8683 2.96337H12.8672Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.9998V25.0832M3.5 8.1665L14 13.9998L3.5 8.1665ZM14 13.9998L24.5 8.1665L14 13.9998Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.0833L19.25 5.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.3828L10.5 16.3335",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.45a691516e6b052b46646cee74b27a28.svg";
export { ForwardRef as ReactComponent };